.header {
  margin-bottom: 20px;
}

.section {
  margin-bottom: 5px;
  padding-top: 12px;
}

.sectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.sectionContent {
  margin-bottom: 20px;
  margin-top: 5px;
}

.warningText {
  flex: 1;
  color: var(--dark-80);
  font-family: 'Sohne', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  max-width: 600px;
  
  &.muted {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: var(--dark-40);
  }

  p {
    margin: 0 0 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }
}

.linkButton {
  text-decoration: underline;
  color: var(--dark-90);
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.01em;
}

.buttonContainer {
  flex-shrink: 0;
  width: 180px;
  display: flex;
  justify-content: flex-end;
}
